const circular = {
    getlist: 'circular/getlist-by-admin',
    add: 'circular/add',
    update: 'circular/update',
    remove: 'circular/remove',
    get: 'circular/get',
    getall: 'circular/getall',
    clearcache: 'circular/clear-cache',
}
export default circular
